import type { NamespaceSchema } from './types';

// Production test-mode knobs. Routes one designated customer to Stripe
// TEST keys, restricts their search to a dedicated test crew's cars
// (cloned via scripts/db-split/0092-seed-test-crew.sql), and overrides
// the platform bid-mode for their bookings. Disabled by default.
//
// Spec: docs/superpowers/specs/2026-05-28-production-test-mode-design.md

export const testModeSettings: NamespaceSchema = {
  namespace: 'test-mode-settings',
  label: 'Test mode (production)',
  description:
    'Routes one designated customer to Stripe TEST keys and a dedicated test crew. Disabled by default. See docs/superpowers/specs/2026-05-28-production-test-mode-design.md.',
  sections: [
    {
      label: 'Toggle',
      description:
        'Master kill switch. When OFF, every helper short-circuits to live behavior — emails below are ignored.',
      fields: [
        {
          kind: 'boolean',
          key: 'enabled',
          label: 'Enable test mode',
          default: false,
          description:
            'When ON, production becomes a live Stripe + test Stripe hybrid for the test customer only. All other customers see live behavior unchanged.',
        },
      ],
    },
    {
      label: 'Identities',
      description: 'Both emails MUST be set when test mode is enabled.',
      fields: [
        {
          kind: 'email',
          key: 'testCustomerEmail',
          label: 'Test customer email',
          placeholder: 'qa+customer@drivecars.ai',
          description:
            'The single QA customer who bypasses live Stripe + sees only the test crew. Lower-case match.',
        },
        {
          kind: 'email',
          key: 'testCrewEmail',
          label: 'Test crew email',
          placeholder: 'qa+crew@drivecars.ai',
          description:
            'Must match the email on app.users WHERE role=vendor (the test crew vendor created by scripts/db-split/0092-seed-test-crew.sql at reserved id 99000).',
        },
      ],
    },
    {
      label: 'Bid mode override',
      description:
        "How bids are dispatched for the test customer's bookings. `Platform default` honors the platform-wide bid-settings.",
      fields: [
        {
          kind: 'select',
          key: 'testCrewBidMode',
          label: 'Bid mode for test-customer bookings',
          default: 'platform_default',
          options: [
            { value: 'platform_default', label: 'Platform default (honor bid-settings.dispatchMode)' },
            { value: 'admin', label: 'Admin match (operator picks the crew manually)' },
            { value: 'broadcast', label: 'Broadcast (auto-invite the test crew)' },
          ],
        },
      ],
    },
  ],
};
